<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card shadow="never">
          <div style="margin-bottom: 10px">
          <el-row>
            <el-col :span="10">
              <el-input v-model="filters[0].value" placeholder="ค้นหาจากชื่อร้าน อีเมล เบอร์โทร userCode"></el-input>
            </el-col>
            <el-col :span="14" class="text-md-right">
              <el-radio-group v-model="statusFilter" @change="onSelectStatusFilter">
                <el-radio-button label="0">New</el-radio-button>
                <el-radio-button label="1">Saved</el-radio-button>
                 <el-radio-button label="2">All</el-radio-button>
              </el-radio-group>
            </el-col>
          </el-row>
        </div>
          <el-row>
            <el-col class="text-md-left" :span="24">
              <data-tables :data="dataList" style="width: 100%" class="dataTable" v-loading="loading" :page-size="10"
                            :pagination-props="{ pageSizes: [10, 20, 50, 100], pagerCount: 5 }" :filters="filters">
                <!-- <el-table-column label="ลำดับ" type="index" width="70"></el-table-column> -->
                <el-table-column prop="shopName" label="ชื่อร้าน" width="230"></el-table-column>
                <el-table-column prop="productQuantity" label="จำนวนออเดอร์" width="170"></el-table-column>
                <el-table-column prop="email" label="อีเมล"></el-table-column>
                <el-table-column label="วันที่สมัคร" width="150">

                  <div
                    class="text-md-left"
                    slot-scope="scope"
                  >
                  {{$dayjs(scope.row.createdAt).format('YYYY-MM-DD HH:mm:ss')}}</div>
                </el-table-column>
                <el-table-column prop="phoneNumber" label="เบอร์โทร" width="170"></el-table-column>
                <el-table-column label="สถานะ" width="170">
                  <div class="text-md-left" slot-scope="scope">
                        <el-select v-model="scope.row.status" placeholder="Select">
                            <el-option
                            v-for="item in QuotationRequesList"
                            :key="item.id"
                            :label="item.label"
                            :value="item.id">
                            </el-option>
                        </el-select>
                  </div>
                </el-table-column>
                <el-table-column label="User Code" width="170" prop="userCode">
                  <div class="text-md-left" slot-scope="scope">
                        <el-input placeholder="User Code" v-model="scope.row.userCode"></el-input>
                  </div>
                </el-table-column>
                 <el-table-column label="Sale Code" width="170" prop="userCode" >
                  <div class="text-md-left" slot-scope="scope">
                    <!-- <el-select
                        v-model="scope.row.saleCode"
                        placeholder="Sale Code"
                        @click.native="remoteMethodSaleCode"
                        :loading="loadingSaleCode">
                        <el-option
                        v-for="item in saleCodeList"
                        :key="item.saleCode"
                        :label="item.saleCode"
                        :value="item.saleCode">
                        </el-option>
                    </el-select> -->
                    <el-select
                        v-model="scope.row.saleCode"
                        placeholder="Sale Code"
                        @click.native="remoteMethodSaleCode"
                        :loading="loadingSaleCode">
                            <el-option-group
                                v-for="group in saleCodeList"
                                :key="group.name"
                                :label="group.name">
                                 <el-option
                                    v-for="item in group.saleCodes"
                                    :key="item.code"
                                    :label="item.code"
                                    :value="item.code">
                                </el-option>
                            </el-option-group>
                    </el-select>
                  </div>
                </el-table-column>

                <el-table-column  label="สถานะแพ็คเกจ" width="150">
                    <div class="text-md-left" slot-scope="scope" >
                        {{getSubscriptionStatusLabel(scope.row.subscriptionStatus)}}
                    </div>
                </el-table-column>

                <el-table-column  label="สถานะการจ่ายเงิน"  width="150">
                    <div class="text-md-left" slot-scope="scope">
                        {{getSubscriptionPaymentStatusLabel(scope.row.subscriptionStatus)}}
                    </div>
                </el-table-column>

                <el-table-column  label="การยืนยันตัวตน"  width="150">
                    <div class="text-md-left" slot-scope="scope">
                        {{getApproveStatusLabel(scope.row.approveStatus, scope.row.isApprove) }}
                    </div>
                </el-table-column>

                <el-table-column label="จัดการ" width="170">
                  <div class="text-md-left" slot-scope="scope">
                        <el-button type="primary" @click="submitData(scope.row)">บันทึก</el-button>
                  </div>
                </el-table-column>
              </data-tables>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
export default {
    name: 'QuotationRequest',
    data () {
        return {
            dataList: [],
            loading: true,
            value: '',
            filters: [
                {
                    prop: ['shopName', 'email', 'phoneNumber', 'userCode'],
                    value: ''
                }
            ],
            options: [],
            loadingSaleCode: false,
            saleCodeList: [],
            statusFilter: 0
        }
    },
    mounted () {
        this.fetchRegis()
    },
    methods: {
        async remoteMethodSaleCode (query) {
            this.loadingSaleCode = true
            try {
                let res = await fgApi.seller.getALlSaleCode()
                if (res.success) {
                    this.saleCodeList = res.data
                }
            } catch (error) {
                console.log(error)
            }
            this.loadingSaleCode = false
        },
        onSelectStatusFilter () {
            this.fetchRegis()
        },
        async fetchRegis () {
            this.loading = true
            let param = {
                offset: null,
                limit: null,
                filter_status: parseInt(this.statusFilter)
            }
            try {
                let res = await fgApi.user.getListRegistedLandingPage(param)
                if (res.success) {
                    this.dataList = res.data
                    console.log(res)
                } else {
                    this.$message({
                        message: 'Oops, Api is error.',
                        type: 'error'
                    })
                }
            } catch (error) {
                this.$message({
                    message: 'Oops, Api is error.',
                    type: 'error'
                })
            }
            this.loading = false
        },
        async submitData (data) {
            this.$loading()
            let param = {
                id: data.id,
                status: data.status,
                userCode: data.userCode,
                saleCode: data.saleCode
            }
            try {
                let res = await fgApi.user.updateLeadPool(param)
                console.log(res)
                if (res.success) {
                    this.$notify({
                        title: 'Success',
                        message: 'อัพเดทสำเร็จ',
                        type: 'success'
                    })
                    this.fetchRegis()
                } else {
                    this.$notify.error({
                        title: 'Error',
                        message: res.message
                    })
                }
            } catch (error) {
                this.$message({
                    message: 'Oops, Api is error.',
                    type: 'error'
                })
            }
            this.$loading().close()
        }
    }
}
</script>

<style lang="scss">

.dataTable {
  th{
    background-color: black;
    color: white;
    // border-right: 1px solid #EBEEF5;
  }
//   td{
    //   border-right: 1px solid #EBEEF5;
//   }
}
</style>
